export enum Roles {
  CLUB_ADMIN = 'CLUB_ADMIN',
  TEAM_LEAD = 'TEAM_LEAD',
  PLAYER = 'PLAYER',
  TREASURER = 'TREASURER',
}
